import { render } from "./DashboardPointStatusSummary.vue?vue&type=template&id=4bd32bd6"
import script from "./DashboardPointStatusSummary.vue?vue&type=script&lang=js"
export * from "./DashboardPointStatusSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__